import { render, staticRenderFns } from "./pageSettings.html?vue&type=template&id=76c02939&scoped=true&external"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=76c02939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c02939",
  null
  
)

export default component.exports